




import {
    Component, Prop, Vue
} from "@zoovu/runner-browser-api";

@Component({})
export default class Flex extends Vue {

    @Prop()
    private col;
}
